import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { Printer } from "gen/printer/models_pb"

import { AppState } from "app/store"

type PrintersState = {
  selectedPrinter: Printer | null
}

const initialState: PrintersState = {
  selectedPrinter: null,
}

export const printersSlice = createSlice({
  name: "printers",
  initialState,
  reducers: {
    setSelectedPrinter: (state, action: PayloadAction<Printer | null>) => {
      state.selectedPrinter = action.payload
    },
  },
})

export const { setSelectedPrinter } = printersSlice.actions

export const selectPrinter = (state: AppState) => state.printers.selectedPrinter
